<template>

    <Panel :header="label" :toggleable="toggleable" :collapsed="toggleable">
        <div class="col-12  md:col-12">
        <DataTable
            :value="listaLogs"
            class="p-datatable-sm"
            dataKey="id">
            <Column header="Usuário" headerStyle="width: 70%">
            <template #body="slotProps">
                {{ slotProps.data.userName }}
            </template>
            </Column>

            <Column header="Descrição">
            <template #body="slotProps">
                {{ slotProps.data.mensagem }}
            </template>
            </Column>

            <Column header="Data">
            <template #body="slotProps">
                {{ formatarDataBR(slotProps.data.dataOperacao) }}
            </template>
            </Column>
        </DataTable>
        </div>
    </Panel>

</template>

<script>

import LogService from "../../service/LogService";

export default {

    props: {
        lista: [],
        label: {
            default:"Mensagens da Inscrição",
        },
        toggleable: {
            mode: Boolean,
            default:true,
        }
    },
    data() {
        return {
            logService: null,
            listaLogs: [],
        }
    },
    created() {
        this.logService = new LogService();
        this.listaLogs = this.lista;
    },
    watch: {
        lista: function(val) {
            this.listaLogs = val;
        },
    },
    methods: {
        formatarDataBR(dataUS) {
        const dataFormatada = new Date(dataUS).toLocaleString();
        return dataFormatada;
        },
    },

}
</script>

<style>
</style>